module.exports = __webpack_public_path__ + "img/roleB.d38ea048.png";